import { ReactNode, useEffect, useRef } from "react";

import { useElementSize } from "hooks/useElementSize";

import { Size } from "./types";

type ResponsiveSVGProps<T> = {
  children?: ReactNode;
  tooltip?: ReactNode;
  chartUpdate: (ref: SVGSVGElement, size: Size, data: T) => void;
  data: T;
};

export const ResponsiveSVG = <T extends object>({
  children,
  tooltip,
  chartUpdate,
  data,
}: ResponsiveSVGProps<T>) => {
  const svgRef = useRef<SVGSVGElement>(null);
  const [ref, size] = useElementSize<HTMLDivElement>();

  useEffect(() => {
    if (svgRef.current) {
      chartUpdate(svgRef.current, size, data);
    }
  }, [chartUpdate, ref, size, data]);

  return (
    <div
      ref={ref}
      style={{
        height: "100%",
        width: "100%",
        overflow: "hidden",
        minWidth: 0,
        minHeight: 0,
        contain: "size layout paint style",
        position: "relative",
      }}
    >
      <svg
        ref={svgRef}
        height={size.height}
        width={size.width}
        style={{
          position: "absolute",
          inset: 0,
          width: `${size.width}px`,
          height: `${size.height}px`,
          display: "block",
        }}
      >
        {children}
      </svg>
      {tooltip}
    </div>
  );
};
